import { render, staticRenderFns } from "./CommentDialog.vue?vue&type=template&id=7424f9da&scoped=true&"
import script from "./CommentDialog.vue?vue&type=script&lang=js&"
export * from "./CommentDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommentDialog.vue?vue&type=style&index=0&id=7424f9da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7424f9da",
  null
  
)

export default component.exports